module.exports = __webpack_public_path__ + "static/media/okobah.9f387de3.jpg";